import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription, Observable} from 'rxjs';
import {Store} from "@ngrx/store";
import {RestUrlsConfig, GenericConfig} from '@signature-it/ngx-generic/config';
import * as fromSelectors from '@signature-it/ngx-catalogue/store/selectors';
import {StockDTO} from '@signature-it/ngx-catalogue/models';
import {TranslateService} from "@ngx-translate/core";

declare let _: any;


@Component({
    selector: 'inventory',
    templateUrl: './inventory.component.html',
    styleUrls: ['./inventory.component.scss'],
    standalone: false
})

export class InventoryComponent implements OnInit, OnDestroy {

    @Input() pCode: number;
    protected subscriptionsList$: Array<Subscription> = [];
    unCommerceApp: boolean = GenericConfig.unCommerceApp || false;
    inventoryCheck = GenericConfig.inventoryCheck;
    showQnty = GenericConfig.showQuantity;
    stockList$: Observable<StockDTO[]>;
    stock = 0;
    stockLoading = true;


    constructor(protected store$: Store<any>,
                protected restUrlsConf: RestUrlsConfig) {
        this.stockList$ = this.store$.select(fromSelectors.getCatalogueStockList);
    }

    ngOnInit() {
        this.registerSubscription();
    }

    registerSubscription() {
        if (!this.unCommerceApp && this.inventoryCheck) {
            let sb1$ = this.stockList$.subscribe((stockList: StockDTO[]) => {
                if (stockList && stockList.length) {
                    let productStock =  _.filter(Array.from(stockList), {'productCode': this.pCode});
                    if(productStock && productStock[0]) {
                        this.stockLoading = false;
                        this.stock = productStock[0]['stock'];
                    }
                }
            });
            this.subscriptionsList$.push(sb1$);
        }
    }

    ngOnDestroy() {
        _.each(this.subscriptionsList$, (s) => s.unsubscribe());
    }
}
